import { SvgIcon, SvgIconProps } from '@mui/material';
import React from 'react';

export const ArrowRightBottom: React.FC<SvgIconProps> = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 18 18" {...props}>
    <path d="M4.11563 3.32433L13.4981 12.7068V6.90183C13.4981 6.59133 13.7501 6.33933 14.0606 6.33933C14.3711 6.33933 14.6231 6.59133 14.6231 6.90183V14.0625C14.6231 14.373 14.3711 14.625 14.0606 14.625H6.9C6.5895 14.625 6.3375 14.373 6.3375 14.0625C6.3375 13.752 6.5895 13.5 6.9 13.5H12.705L3.3225 4.11746C3.23869 4.01958 3.1875 3.89189 3.1875 3.75183C3.1875 3.44133 3.4395 3.18933 3.75 3.18933C3.89006 3.18933 4.01831 3.24052 4.11675 3.32546L4.11619 3.32489L4.11563 3.32433Z" />
  </SvgIcon>
);
